//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mdiDotsVertical } from '@mdi/js'

export default {
  setup() {
    return {
      icons: {
        mdiDotsVertical,
      },
    }
  },
}
